import { Maybe } from '@monetize/types/common';

export interface CountryWithState {
  name: string;
  isoCode: string;
  states: CountryState[];
}

export interface CountryState {
  name: string;
  isoCode: string;
}

export type CountryStateMap = Record<string, CountryState[]>;

export const countriesWithStates = [
  {
    name: 'Afghanistan',
    isoCode: 'AF',
    states: [],
  },
  {
    name: 'Aland Islands',
    isoCode: 'AX',
    states: [],
  },
  {
    name: 'Albania',
    isoCode: 'AL',
    states: [],
  },
  {
    name: 'Algeria',
    isoCode: 'DZ',
    states: [],
  },
  {
    name: 'American Samoa',
    isoCode: 'AS',
    states: [],
  },
  {
    name: 'Andorra',
    isoCode: 'AD',
    states: [],
  },
  {
    name: 'Angola',
    isoCode: 'AO',
    states: [],
  },
  {
    name: 'Anguilla',
    isoCode: 'AI',
    states: [],
  },
  {
    name: 'Antarctica',
    isoCode: 'AQ',
    states: [],
  },
  {
    name: 'Antigua And Barbuda',
    isoCode: 'AG',
    states: [],
  },
  {
    name: 'Argentina',
    isoCode: 'AR',
    states: [
      {
        name: 'Buenos Aires',
        isoCode: 'B',
      },
      {
        name: 'Catamarca',
        isoCode: 'K',
      },
      {
        name: 'Chaco',
        isoCode: 'H',
      },
      {
        name: 'Chubut',
        isoCode: 'U',
      },
      {
        name: 'Ciudad Autónoma de Buenos Aires',
        isoCode: 'C',
      },
      {
        name: 'Córdoba',
        isoCode: 'X',
      },
      {
        name: 'Corrientes',
        isoCode: 'W',
      },
      {
        name: 'Entre Ríos',
        isoCode: 'E',
      },
      {
        name: 'Formosa',
        isoCode: 'P',
      },
      {
        name: 'Jujuy',
        isoCode: 'Y',
      },
      {
        name: 'La Pampa',
        isoCode: 'L',
      },
      {
        name: 'La Rioja',
        isoCode: 'F',
      },
      {
        name: 'Mendoza',
        isoCode: 'M',
      },
      {
        name: 'Misiones',
        isoCode: 'N',
      },
      {
        name: 'Neuquén',
        isoCode: 'Q',
      },
      {
        name: 'Río Negro',
        isoCode: 'R',
      },
      {
        name: 'Salta',
        isoCode: 'A',
      },
      {
        name: 'San Juan',
        isoCode: 'J',
      },
      {
        name: 'San Luis',
        isoCode: 'D',
      },
      {
        name: 'Santa Cruz',
        isoCode: 'Z',
      },
      {
        name: 'Santa Fe',
        isoCode: 'S',
      },
      {
        name: 'Santiago del Estero',
        isoCode: 'G',
      },
      {
        name: 'Tierra del Fuego',
        isoCode: 'V',
      },
      {
        name: 'Tucumán',
        isoCode: 'T',
      },
    ],
  },
  {
    name: 'Armenia',
    isoCode: 'AM',
    states: [],
  },
  {
    name: 'Aruba',
    isoCode: 'AW',
    states: [],
  },
  {
    name: 'Australia',
    isoCode: 'AU',
    states: [
      {
        name: 'Australian Capital Territory',
        isoCode: 'ACT',
      },
      {
        name: 'New South Wales',
        isoCode: 'NSW',
      },
      {
        name: 'Northern Territory',
        isoCode: 'NT',
      },
      {
        name: 'Queensland',
        isoCode: 'QLD',
      },
      {
        name: 'South Australia',
        isoCode: 'SA',
      },
      {
        name: 'Tasmania',
        isoCode: 'TAS',
      },
      {
        name: 'Victoria',
        isoCode: 'VIC',
      },
      {
        name: 'Western Australia',
        isoCode: 'WA',
      },
    ],
  },
  {
    name: 'Austria',
    isoCode: 'AT',
    states: [],
  },
  {
    name: 'Azerbaijan',
    isoCode: 'AZ',
    states: [],
  },
  {
    name: 'Bahrain',
    isoCode: 'BH',
    states: [],
  },
  {
    name: 'Bangladesh',
    isoCode: 'BD',
    states: [],
  },
  {
    name: 'Barbados',
    isoCode: 'BB',
    states: [],
  },
  {
    name: 'Belarus',
    isoCode: 'BY',
    states: [],
  },
  {
    name: 'Belgium',
    isoCode: 'BE',
    states: [],
  },
  {
    name: 'Belize',
    isoCode: 'BZ',
    states: [],
  },
  {
    name: 'Benin',
    isoCode: 'BJ',
    states: [],
  },
  {
    name: 'Bermuda',
    isoCode: 'BM',
    states: [],
  },
  {
    name: 'Bhutan',
    isoCode: 'BT',
    states: [],
  },
  {
    name: 'Bolivia',
    isoCode: 'BO',
    states: [],
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    isoCode: 'BQ',
    states: [],
  },
  {
    name: 'Bosnia and Herzegovina',
    isoCode: 'BA',
    states: [],
  },
  {
    name: 'Botswana',
    isoCode: 'BW',
    states: [],
  },
  {
    name: 'Bouvet Island',
    isoCode: 'BV',
    states: [],
  },
  {
    name: 'Brazil',
    isoCode: 'BR',
    states: [
      {
        name: 'Acre',
        isoCode: 'AC',
      },
      {
        name: 'Alagoas',
        isoCode: 'AL',
      },
      {
        name: 'Amapá',
        isoCode: 'AP',
      },
      {
        name: 'Amazonas',
        isoCode: 'AM',
      },
      {
        name: 'Bahia',
        isoCode: 'BA',
      },
      {
        name: 'Ceará',
        isoCode: 'CE',
      },
      {
        name: 'Distrito Federal',
        isoCode: 'DF',
      },
      {
        name: 'Espírito Santo',
        isoCode: 'ES',
      },
      {
        name: 'Goiás',
        isoCode: 'GO',
      },
      {
        name: 'Maranhão',
        isoCode: 'MA',
      },
      {
        name: 'Mato Grosso',
        isoCode: 'MT',
      },
      {
        name: 'Mato Grosso do Sul',
        isoCode: 'MS',
      },
      {
        name: 'Minas Gerais',
        isoCode: 'MG',
      },
      {
        name: 'Pará',
        isoCode: 'PA',
      },
      {
        name: 'Paraíba',
        isoCode: 'PB',
      },
      {
        name: 'Paraná',
        isoCode: 'PR',
      },
      {
        name: 'Pernambuco',
        isoCode: 'PE',
      },
      {
        name: 'Piauí',
        isoCode: 'PI',
      },
      {
        name: 'Rio de Janeiro',
        isoCode: 'RJ',
      },
      {
        name: 'Rio Grande do Norte',
        isoCode: 'RN',
      },
      {
        name: 'Rio Grande do Sul',
        isoCode: 'RS',
      },
      {
        name: 'Rondônia',
        isoCode: 'RO',
      },
      {
        name: 'Roraima',
        isoCode: 'RR',
      },
      {
        name: 'Santa Catarina',
        isoCode: 'SC',
      },
      {
        name: 'São Paulo',
        isoCode: 'SP',
      },
      {
        name: 'Sergipe',
        isoCode: 'SE',
      },
      {
        name: 'Tocantins',
        isoCode: 'TO',
      },
    ],
  },
  {
    name: 'British Indian Ocean Territory',
    isoCode: 'IO',
    states: [],
  },
  {
    name: 'Brunei',
    isoCode: 'BN',
    states: [],
  },
  {
    name: 'Bulgaria',
    isoCode: 'BG',
    states: [],
  },
  {
    name: 'Burkina Faso',
    isoCode: 'BF',
    states: [],
  },
  {
    name: 'Burundi',
    isoCode: 'BI',
    states: [],
  },
  {
    name: 'Cambodia',
    isoCode: 'KH',
    states: [],
  },
  {
    name: 'Cameroon',
    isoCode: 'CM',
    states: [],
  },
  {
    name: 'Canada',
    isoCode: 'CA',
    states: [
      {
        name: 'Alberta',
        isoCode: 'AB',
      },
      {
        name: 'British Columbia',
        isoCode: 'BC',
      },
      {
        name: 'Manitoba',
        isoCode: 'MB',
      },
      {
        name: 'New Brunswick',
        isoCode: 'NB',
      },
      {
        name: 'Newfoundland and Labrador',
        isoCode: 'NL',
      },
      {
        name: 'Northwest Territories',
        isoCode: 'NT',
      },
      {
        name: 'Nova Scotia',
        isoCode: 'NS',
      },
      {
        name: 'Nunavut',
        isoCode: 'NU',
      },
      {
        name: 'Ontario',
        isoCode: 'ON',
      },
      {
        name: 'Prince Edward Island',
        isoCode: 'PE',
      },
      {
        name: 'Quebec',
        isoCode: 'QC',
      },
      {
        name: 'Saskatchewan',
        isoCode: 'SK',
      },
      {
        name: 'Yukon',
        isoCode: 'YT',
      },
    ],
  },
  {
    name: 'Cape Verde',
    isoCode: 'CV',
    states: [],
  },
  {
    name: 'Cayman Islands',
    isoCode: 'KY',
    states: [],
  },
  {
    name: 'Central African Republic',
    isoCode: 'CF',
    states: [],
  },
  {
    name: 'Chad',
    isoCode: 'TD',
    states: [],
  },
  {
    name: 'Chile',
    isoCode: 'CL',
    states: [],
  },
  {
    name: 'China',
    isoCode: 'CN',
    states: [
      {
        name: 'Anhui',
        isoCode: 'AH',
      },
      {
        name: 'Beijing',
        isoCode: 'BJ',
      },
      {
        name: 'Chongqing',
        isoCode: 'CQ',
      },
      {
        name: 'Fujian',
        isoCode: 'FJ',
      },
      {
        name: 'Gansu',
        isoCode: 'GS',
      },
      {
        name: 'Guangdong',
        isoCode: 'GD',
      },
      {
        name: 'Guangxi Zhuang',
        isoCode: 'GX',
      },
      {
        name: 'Guizhou',
        isoCode: 'GZ',
      },
      {
        name: 'Hainan',
        isoCode: 'HI',
      },
      {
        name: 'Hebei',
        isoCode: 'HE',
      },
      {
        name: 'Heilongjiang',
        isoCode: 'HL',
      },
      {
        name: 'Henan',
        isoCode: 'HA',
      },
      {
        name: 'Hong Kong SAR',
        isoCode: 'HK',
      },
      {
        name: 'Hubei',
        isoCode: 'HB',
      },
      {
        name: 'Hunan',
        isoCode: 'HN',
      },
      {
        name: 'Inner Mongolia',
        isoCode: 'NM',
      },
      {
        name: 'Jiangsu',
        isoCode: 'JS',
      },
      {
        name: 'Jiangxi',
        isoCode: 'JX',
      },
      {
        name: 'Jilin',
        isoCode: 'JL',
      },
      {
        name: 'Liaoning',
        isoCode: 'LN',
      },
      {
        name: 'Macau SAR',
        isoCode: 'MO',
      },
      {
        name: 'Ningxia Huizu',
        isoCode: 'NX',
      },
      {
        name: 'Qinghai',
        isoCode: 'QH',
      },
      {
        name: 'Shaanxi',
        isoCode: 'SN',
      },
      {
        name: 'Shandong',
        isoCode: 'SD',
      },
      {
        name: 'Shanghai',
        isoCode: 'SH',
      },
      {
        name: 'Shanxi',
        isoCode: 'SX',
      },
      {
        name: 'Sichuan',
        isoCode: 'SC',
      },
      {
        name: 'Taiwan',
        isoCode: 'TW',
      },
      {
        name: 'Tianjin',
        isoCode: 'TJ',
      },
      {
        name: 'Xinjiang',
        isoCode: 'XJ',
      },
      {
        name: 'Xizang',
        isoCode: 'XZ',
      },
      {
        name: 'Yunnan',
        isoCode: 'YN',
      },
      {
        name: 'Zhejiang',
        isoCode: 'ZJ',
      },
    ],
  },
  {
    name: 'Christmas Island',
    isoCode: 'CX',
    states: [],
  },
  {
    name: 'Cocos (Keeling) Islands',
    isoCode: 'CC',
    states: [],
  },
  {
    name: 'Colombia',
    isoCode: 'CO',
    states: [],
  },
  {
    name: 'Comoros',
    isoCode: 'KM',
    states: [],
  },
  {
    name: 'Congo',
    isoCode: 'CG',
    states: [],
  },
  {
    name: 'Cook Islands',
    isoCode: 'CK',
    states: [],
  },
  {
    name: 'Costa Rica',
    isoCode: 'CR',
    states: [],
  },
  {
    name: "Cote D'Ivoire (Ivory Coast)",
    isoCode: 'CI',
    states: [],
  },
  {
    name: 'Croatia',
    isoCode: 'HR',
    states: [],
  },
  {
    name: 'Cuba',
    isoCode: 'CU',
    states: [],
  },
  {
    name: 'Curaçao',
    isoCode: 'CW',
    states: [],
  },
  {
    name: 'Cyprus',
    isoCode: 'CY',
    states: [],
  },
  {
    name: 'Czech Republic',
    isoCode: 'CZ',
    states: [],
  },
  {
    name: 'Democratic Republic of the Congo',
    isoCode: 'CD',
    states: [],
  },
  {
    name: 'Denmark',
    isoCode: 'DK',
    states: [],
  },
  {
    name: 'Djibouti',
    isoCode: 'DJ',
    states: [],
  },
  {
    name: 'Dominica',
    isoCode: 'DM',
    states: [],
  },
  {
    name: 'Dominican Republic',
    isoCode: 'DO',
    states: [],
  },
  {
    name: 'East Timor',
    isoCode: 'TL',
    states: [],
  },
  {
    name: 'Ecuador',
    isoCode: 'EC',
    states: [],
  },
  {
    name: 'Egypt',
    isoCode: 'EG',
    states: [],
  },
  {
    name: 'El Salvador',
    isoCode: 'SV',
    states: [],
  },
  {
    name: 'Equatorial Guinea',
    isoCode: 'GQ',
    states: [],
  },
  {
    name: 'Eritrea',
    isoCode: 'ER',
    states: [],
  },
  {
    name: 'Estonia',
    isoCode: 'EE',
    states: [],
  },
  {
    name: 'Ethiopia',
    isoCode: 'ET',
    states: [],
  },
  {
    name: 'Falkland Islands',
    isoCode: 'FK',
    states: [],
  },
  {
    name: 'Faroe Islands',
    isoCode: 'FO',
    states: [],
  },
  {
    name: 'Fiji Islands',
    isoCode: 'FJ',
    states: [],
  },
  {
    name: 'Finland',
    isoCode: 'FI',
    states: [],
  },
  {
    name: 'France',
    isoCode: 'FR',
    states: [],
  },
  {
    name: 'French Guiana',
    isoCode: 'GF',
    states: [],
  },
  {
    name: 'French Polynesia',
    isoCode: 'PF',
    states: [],
  },
  {
    name: 'French Southern Territories',
    isoCode: 'TF',
    states: [],
  },
  {
    name: 'Gabon',
    isoCode: 'GA',
    states: [],
  },
  {
    name: 'Gambia The',
    isoCode: 'GM',
    states: [],
  },
  {
    name: 'Georgia',
    isoCode: 'GE',
    states: [],
  },
  {
    name: 'Germany',
    isoCode: 'DE',
    states: [],
  },
  {
    name: 'Ghana',
    isoCode: 'GH',
    states: [],
  },
  {
    name: 'Gibraltar',
    isoCode: 'GI',
    states: [],
  },
  {
    name: 'Greece',
    isoCode: 'GR',
    states: [],
  },
  {
    name: 'Greenland',
    isoCode: 'GL',
    states: [],
  },
  {
    name: 'Grenada',
    isoCode: 'GD',
    states: [],
  },
  {
    name: 'Guadeloupe',
    isoCode: 'GP',
    states: [],
  },
  {
    name: 'Guam',
    isoCode: 'GU',
    states: [],
  },
  {
    name: 'Guatemala',
    isoCode: 'GT',
    states: [],
  },
  {
    name: 'Guernsey and Alderney',
    isoCode: 'GG',
    states: [],
  },
  {
    name: 'Guinea',
    isoCode: 'GN',
    states: [],
  },
  {
    name: 'Guinea-Bissau',
    isoCode: 'GW',
    states: [],
  },
  {
    name: 'Guyana',
    isoCode: 'GY',
    states: [],
  },
  {
    name: 'Haiti',
    isoCode: 'HT',
    states: [],
  },
  {
    name: 'Heard Island and McDonald Islands',
    isoCode: 'HM',
    states: [],
  },
  {
    name: 'Honduras',
    isoCode: 'HN',
    states: [],
  },
  {
    name: 'Hong Kong S.A.R.',
    isoCode: 'HK',
    states: [],
  },
  {
    name: 'Hungary',
    isoCode: 'HU',
    states: [],
  },
  {
    name: 'Iceland',
    isoCode: 'IS',
    states: [],
  },
  {
    name: 'India',
    isoCode: 'IN',
    states: [
      {
        name: 'Andaman and Nicobar Islands',
        isoCode: 'AN',
      },
      {
        name: 'Andhra Pradesh',
        isoCode: 'AP',
      },
      {
        name: 'Arunachal Pradesh',
        isoCode: 'AR',
      },
      {
        name: 'Assam',
        isoCode: 'AS',
      },
      {
        name: 'Bihar',
        isoCode: 'BR',
      },
      {
        name: 'Chandigarh',
        isoCode: 'CH',
      },
      {
        name: 'Chhattisgarh',
        isoCode: 'CT',
      },
      {
        name: 'Dadra and Nagar Haveli and Daman and Diu',
        isoCode: 'DH',
      },
      {
        name: 'Delhi',
        isoCode: 'DL',
      },
      {
        name: 'Goa',
        isoCode: 'GA',
      },
      {
        name: 'Gujarat',
        isoCode: 'GJ',
      },
      {
        name: 'Haryana',
        isoCode: 'HR',
      },
      {
        name: 'Himachal Pradesh',
        isoCode: 'HP',
      },
      {
        name: 'Jammu and Kashmir',
        isoCode: 'JK',
      },
      {
        name: 'Jharkhand',
        isoCode: 'JH',
      },
      {
        name: 'Karnataka',
        isoCode: 'KA',
      },
      {
        name: 'Kerala',
        isoCode: 'KL',
      },
      {
        name: 'Ladakh',
        isoCode: 'LA',
      },
      {
        name: 'Lakshadweep',
        isoCode: 'LD',
      },
      {
        name: 'Madhya Pradesh',
        isoCode: 'MP',
      },
      {
        name: 'Maharashtra',
        isoCode: 'MH',
      },
      {
        name: 'Manipur',
        isoCode: 'MN',
      },
      {
        name: 'Meghalaya',
        isoCode: 'ML',
      },
      {
        name: 'Mizoram',
        isoCode: 'MZ',
      },
      {
        name: 'Nagaland',
        isoCode: 'NL',
      },
      {
        name: 'Odisha',
        isoCode: 'OR',
      },
      {
        name: 'Puducherry',
        isoCode: 'PY',
      },
      {
        name: 'Punjab',
        isoCode: 'PB',
      },
      {
        name: 'Rajasthan',
        isoCode: 'RJ',
      },
      {
        name: 'Sikkim',
        isoCode: 'SK',
      },
      {
        name: 'Tamil Nadu',
        isoCode: 'TN',
      },
      {
        name: 'Telangana',
        isoCode: 'TG',
      },
      {
        name: 'Tripura',
        isoCode: 'TR',
      },
      {
        name: 'Uttar Pradesh',
        isoCode: 'UP',
      },
      {
        name: 'Uttarakhand',
        isoCode: 'UT',
      },
      {
        name: 'West Bengal',
        isoCode: 'WB',
      },
    ],
  },
  {
    name: 'Indonesia',
    isoCode: 'ID',
    states: [
      {
        name: 'Aceh',
        isoCode: 'AC',
      },
      {
        name: 'Bali',
        isoCode: 'BA',
      },
      {
        name: 'Banten',
        isoCode: 'BT',
      },
      {
        name: 'Bengkulu',
        isoCode: 'BE',
      },
      {
        name: 'DI Yogyakarta',
        isoCode: 'YO',
      },
      {
        name: 'DKI Jakarta',
        isoCode: 'JK',
      },
      {
        name: 'Gorontalo',
        isoCode: 'GO',
      },
      {
        name: 'Jambi',
        isoCode: 'JA',
      },
      {
        name: 'Jawa Barat',
        isoCode: 'JB',
      },
      {
        name: 'Jawa Tengah',
        isoCode: 'JT',
      },
      {
        name: 'Jawa Timur',
        isoCode: 'JI',
      },
      {
        name: 'Kalimantan Barat',
        isoCode: 'KB',
      },
      {
        name: 'Kalimantan Selatan',
        isoCode: 'KS',
      },
      {
        name: 'Kalimantan Tengah',
        isoCode: 'KT',
      },
      {
        name: 'Kalimantan Timur',
        isoCode: 'KI',
      },
      {
        name: 'Kalimantan Utara',
        isoCode: 'KU',
      },
      {
        name: 'Kepulauan Bangka Belitung',
        isoCode: 'BB',
      },
      {
        name: 'Kepulauan Riau',
        isoCode: 'KR',
      },
      {
        name: 'Lampung',
        isoCode: 'LA',
      },
      {
        name: 'Maluku',
        isoCode: 'MA',
      },
      {
        name: 'Maluku Utara',
        isoCode: 'MU',
      },
      {
        name: 'Nusa Tenggara Barat',
        isoCode: 'NB',
      },
      {
        name: 'Nusa Tenggara Timur',
        isoCode: 'NT',
      },
      {
        name: 'Papua',
        isoCode: 'PA',
      },
      {
        name: 'Papua Barat',
        isoCode: 'PB',
      },
      {
        name: 'Riau',
        isoCode: 'RI',
      },
      {
        name: 'Sulawesi Barat',
        isoCode: 'SR',
      },
      {
        name: 'Sulawesi Selatan',
        isoCode: 'SN',
      },
      {
        name: 'Sulawesi Tengah',
        isoCode: 'ST',
      },
      {
        name: 'Sulawesi Tenggara',
        isoCode: 'SG',
      },
      {
        name: 'Sulawesi Utara',
        isoCode: 'SA',
      },
      {
        name: 'Sumatera Barat',
        isoCode: 'SB',
      },
      {
        name: 'Sumatera Selatan',
        isoCode: 'SS',
      },
      {
        name: 'Sumatera Utara',
        isoCode: 'SU',
      },
    ],
  },
  {
    name: 'Iran',
    isoCode: 'IR',
    states: [],
  },
  {
    name: 'Iraq',
    isoCode: 'IQ',
    states: [],
  },
  {
    name: 'Ireland',
    isoCode: 'IE',
    states: [],
  },
  {
    name: 'Israel',
    isoCode: 'IL',
    states: [],
  },
  {
    name: 'Italy',
    isoCode: 'IT',
    states: [],
  },
  {
    name: 'Jamaica',
    isoCode: 'JM',
    states: [],
  },
  {
    name: 'Japan',
    isoCode: 'JP',
    states: [
      {
        name: 'Aichi Prefecture',
        isoCode: '23',
      },
      {
        name: 'Akita Prefecture',
        isoCode: '05',
      },
      {
        name: 'Aomori Prefecture',
        isoCode: '02',
      },
      {
        name: 'Chiba Prefecture',
        isoCode: '12',
      },
      {
        name: 'Ehime Prefecture',
        isoCode: '38',
      },
      {
        name: 'Fukui Prefecture',
        isoCode: '18',
      },
      {
        name: 'Fukuoka Prefecture',
        isoCode: '40',
      },
      {
        name: 'Fukushima Prefecture',
        isoCode: '07',
      },
      {
        name: 'Gifu Prefecture',
        isoCode: '21',
      },
      {
        name: 'Gunma Prefecture',
        isoCode: '10',
      },
      {
        name: 'Hiroshima Prefecture',
        isoCode: '34',
      },
      {
        name: 'Hokkaidō Prefecture',
        isoCode: '01',
      },
      {
        name: 'Hyōgo Prefecture',
        isoCode: '28',
      },
      {
        name: 'Ibaraki Prefecture',
        isoCode: '08',
      },
      {
        name: 'Ishikawa Prefecture',
        isoCode: '17',
      },
      {
        name: 'Iwate Prefecture',
        isoCode: '03',
      },
      {
        name: 'Kagawa Prefecture',
        isoCode: '37',
      },
      {
        name: 'Kagoshima Prefecture',
        isoCode: '46',
      },
      {
        name: 'Kanagawa Prefecture',
        isoCode: '14',
      },
      {
        name: 'Kōchi Prefecture',
        isoCode: '39',
      },
      {
        name: 'Kumamoto Prefecture',
        isoCode: '43',
      },
      {
        name: 'Kyōto Prefecture',
        isoCode: '26',
      },
      {
        name: 'Mie Prefecture',
        isoCode: '24',
      },
      {
        name: 'Miyagi Prefecture',
        isoCode: '04',
      },
      {
        name: 'Miyazaki Prefecture',
        isoCode: '45',
      },
      {
        name: 'Nagano Prefecture',
        isoCode: '20',
      },
      {
        name: 'Nagasaki Prefecture',
        isoCode: '42',
      },
      {
        name: 'Nara Prefecture',
        isoCode: '29',
      },
      {
        name: 'Niigata Prefecture',
        isoCode: '15',
      },
      {
        name: 'Ōita Prefecture',
        isoCode: '44',
      },
      {
        name: 'Okayama Prefecture',
        isoCode: '33',
      },
      {
        name: 'Okinawa Prefecture',
        isoCode: '47',
      },
      {
        name: 'Ōsaka Prefecture',
        isoCode: '27',
      },
      {
        name: 'Saga Prefecture',
        isoCode: '41',
      },
      {
        name: 'Saitama Prefecture',
        isoCode: '11',
      },
      {
        name: 'Shiga Prefecture',
        isoCode: '25',
      },
      {
        name: 'Shimane Prefecture',
        isoCode: '32',
      },
      {
        name: 'Shizuoka Prefecture',
        isoCode: '22',
      },
      {
        name: 'Tochigi Prefecture',
        isoCode: '09',
      },
      {
        name: 'Tokushima Prefecture',
        isoCode: '36',
      },
      {
        name: 'Tokyo',
        isoCode: '13',
      },
      {
        name: 'Tottori Prefecture',
        isoCode: '31',
      },
      {
        name: 'Toyama Prefecture',
        isoCode: '16',
      },
      {
        name: 'Wakayama Prefecture',
        isoCode: '30',
      },
      {
        name: 'Yamagata Prefecture',
        isoCode: '06',
      },
      {
        name: 'Yamaguchi Prefecture',
        isoCode: '35',
      },
      {
        name: 'Yamanashi Prefecture',
        isoCode: '19',
      },
    ],
  },
  {
    name: 'Jersey',
    isoCode: 'JE',
    states: [],
  },
  {
    name: 'Jordan',
    isoCode: 'JO',
    states: [],
  },
  {
    name: 'Kazakhstan',
    isoCode: 'KZ',
    states: [],
  },
  {
    name: 'Kenya',
    isoCode: 'KE',
    states: [],
  },
  {
    name: 'Kiribati',
    isoCode: 'KI',
    states: [],
  },
  {
    name: 'Kosovo',
    isoCode: 'XK',
    states: [],
  },
  {
    name: 'Kuwait',
    isoCode: 'KW',
    states: [],
  },
  {
    name: 'Kyrgyzstan',
    isoCode: 'KG',
    states: [],
  },
  {
    name: 'Laos',
    isoCode: 'LA',
    states: [],
  },
  {
    name: 'Latvia',
    isoCode: 'LV',
    states: [],
  },
  {
    name: 'Lebanon',
    isoCode: 'LB',
    states: [],
  },
  {
    name: 'Lesotho',
    isoCode: 'LS',
    states: [],
  },
  {
    name: 'Liberia',
    isoCode: 'LR',
    states: [],
  },
  {
    name: 'Libya',
    isoCode: 'LY',
    states: [],
  },
  {
    name: 'Liechtenstein',
    isoCode: 'LI',
    states: [],
  },
  {
    name: 'Lithuania',
    isoCode: 'LT',
    states: [],
  },
  {
    name: 'Luxembourg',
    isoCode: 'LU',
    states: [],
  },
  {
    name: 'Macau S.A.R.',
    isoCode: 'MO',
    states: [],
  },
  {
    name: 'Macedonia',
    isoCode: 'MK',
    states: [],
  },
  {
    name: 'Madagascar',
    isoCode: 'MG',
    states: [],
  },
  {
    name: 'Malawi',
    isoCode: 'MW',
    states: [],
  },
  {
    name: 'Malaysia',
    isoCode: 'MY',
    states: [],
  },
  {
    name: 'Maldives',
    isoCode: 'MV',
    states: [],
  },
  {
    name: 'Mali',
    isoCode: 'ML',
    states: [],
  },
  {
    name: 'Malta',
    isoCode: 'MT',
    states: [],
  },
  {
    name: 'Man (Isle of)',
    isoCode: 'IM',
    states: [],
  },
  {
    name: 'Marshall Islands',
    isoCode: 'MH',
    states: [],
  },
  {
    name: 'Martinique',
    isoCode: 'MQ',
    states: [],
  },
  {
    name: 'Mauritania',
    isoCode: 'MR',
    states: [],
  },
  {
    name: 'Mauritius',
    isoCode: 'MU',
    states: [],
  },
  {
    name: 'Mayotte',
    isoCode: 'YT',
    states: [],
  },
  {
    name: 'Mexico',
    isoCode: 'MX',
    states: [
      {
        name: 'Aguascalientes',
        isoCode: 'AGU',
      },
      {
        name: 'Baja California',
        isoCode: 'BCN',
      },
      {
        name: 'Baja California Sur',
        isoCode: 'BCS',
      },
      {
        name: 'Campeche',
        isoCode: 'CAM',
      },
      {
        name: 'Chiapas',
        isoCode: 'CHP',
      },
      {
        name: 'Chihuahua',
        isoCode: 'CHH',
      },
      {
        name: 'Ciudad de México',
        isoCode: 'CDMX',
      },
      {
        name: 'Coahuila de Zaragoza',
        isoCode: 'COA',
      },
      {
        name: 'Colima',
        isoCode: 'COL',
      },
      {
        name: 'Durango',
        isoCode: 'DUR',
      },
      {
        name: 'Estado de México',
        isoCode: 'MEX',
      },
      {
        name: 'Guanajuato',
        isoCode: 'GUA',
      },
      {
        name: 'Guerrero',
        isoCode: 'GRO',
      },
      {
        name: 'Hidalgo',
        isoCode: 'HID',
      },
      {
        name: 'Jalisco',
        isoCode: 'JAL',
      },
      {
        name: 'Michoacán de Ocampo',
        isoCode: 'MIC',
      },
      {
        name: 'Morelos',
        isoCode: 'MOR',
      },
      {
        name: 'Nayarit',
        isoCode: 'NAY',
      },
      {
        name: 'Nuevo León',
        isoCode: 'NLE',
      },
      {
        name: 'Oaxaca',
        isoCode: 'OAX',
      },
      {
        name: 'Puebla',
        isoCode: 'PUE',
      },
      {
        name: 'Querétaro',
        isoCode: 'QUE',
      },
      {
        name: 'Quintana Roo',
        isoCode: 'ROO',
      },
      {
        name: 'San Luis Potosí',
        isoCode: 'SLP',
      },
      {
        name: 'Sinaloa',
        isoCode: 'SIN',
      },
      {
        name: 'Sonora',
        isoCode: 'SON',
      },
      {
        name: 'Tabasco',
        isoCode: 'TAB',
      },
      {
        name: 'Tamaulipas',
        isoCode: 'TAM',
      },
      {
        name: 'Tlaxcala',
        isoCode: 'TLA',
      },
      {
        name: 'Veracruz de Ignacio de la Llave',
        isoCode: 'VER',
      },
      {
        name: 'Yucatán',
        isoCode: 'YUC',
      },
      {
        name: 'Zacatecas',
        isoCode: 'ZAC',
      },
    ],
  },
  {
    name: 'Micronesia',
    isoCode: 'FM',
    states: [],
  },
  {
    name: 'Moldova',
    isoCode: 'MD',
    states: [],
  },
  {
    name: 'Monaco',
    isoCode: 'MC',
    states: [],
  },
  {
    name: 'Mongolia',
    isoCode: 'MN',
    states: [],
  },
  {
    name: 'Montenegro',
    isoCode: 'ME',
    states: [],
  },
  {
    name: 'Montserrat',
    isoCode: 'MS',
    states: [],
  },
  {
    name: 'Morocco',
    isoCode: 'MA',
    states: [],
  },
  {
    name: 'Mozambique',
    isoCode: 'MZ',
    states: [],
  },
  {
    name: 'Myanmar',
    isoCode: 'MM',
    states: [],
  },
  {
    name: 'Namibia',
    isoCode: 'NA',
    states: [],
  },
  {
    name: 'Nauru',
    isoCode: 'NR',
    states: [],
  },
  {
    name: 'Nepal',
    isoCode: 'NP',
    states: [],
  },
  {
    name: 'Netherlands',
    isoCode: 'NL',
    states: [],
  },
  {
    name: 'New Caledonia',
    isoCode: 'NC',
    states: [],
  },
  {
    name: 'New Zealand',
    isoCode: 'NZ',
    states: [],
  },
  {
    name: 'Nicaragua',
    isoCode: 'NI',
    states: [],
  },
  {
    name: 'Niger',
    isoCode: 'NE',
    states: [],
  },
  {
    name: 'Nigeria',
    isoCode: 'NG',
    states: [
      {
        name: 'Abia',
        isoCode: 'AB',
      },
      {
        name: 'Abuja Federal Capital Territory',
        isoCode: 'FC',
      },
      {
        name: 'Adamawa',
        isoCode: 'AD',
      },
      {
        name: 'Akwa Ibom',
        isoCode: 'AK',
      },
      {
        name: 'Anambra',
        isoCode: 'AN',
      },
      {
        name: 'Bauchi',
        isoCode: 'BA',
      },
      {
        name: 'Bayelsa',
        isoCode: 'BY',
      },
      {
        name: 'Benue',
        isoCode: 'BE',
      },
      {
        name: 'Borno',
        isoCode: 'BO',
      },
      {
        name: 'Cross River',
        isoCode: 'CR',
      },
      {
        name: 'Delta',
        isoCode: 'DE',
      },
      {
        name: 'Ebonyi',
        isoCode: 'EB',
      },
      {
        name: 'Edo',
        isoCode: 'ED',
      },
      {
        name: 'Ekiti',
        isoCode: 'EK',
      },
      {
        name: 'Enugu',
        isoCode: 'EN',
      },
      {
        name: 'Gombe',
        isoCode: 'GO',
      },
      {
        name: 'Imo',
        isoCode: 'IM',
      },
      {
        name: 'Jigawa',
        isoCode: 'JI',
      },
      {
        name: 'Kaduna',
        isoCode: 'KD',
      },
      {
        name: 'Kano',
        isoCode: 'KN',
      },
      {
        name: 'Katsina',
        isoCode: 'KT',
      },
      {
        name: 'Kebbi',
        isoCode: 'KE',
      },
      {
        name: 'Kogi',
        isoCode: 'KO',
      },
      {
        name: 'Kwara',
        isoCode: 'KW',
      },
      {
        name: 'Lagos',
        isoCode: 'LA',
      },
      {
        name: 'Nasarawa',
        isoCode: 'NA',
      },
      {
        name: 'Niger',
        isoCode: 'NI',
      },
      {
        name: 'Ogun',
        isoCode: 'OG',
      },
      {
        name: 'Ondo',
        isoCode: 'ON',
      },
      {
        name: 'Osun',
        isoCode: 'OS',
      },
      {
        name: 'Oyo',
        isoCode: 'OY',
      },
      {
        name: 'Plateau',
        isoCode: 'PL',
      },
      {
        name: 'Rivers',
        isoCode: 'RI',
      },
      {
        name: 'Sokoto',
        isoCode: 'SO',
      },
      {
        name: 'Taraba',
        isoCode: 'TA',
      },
      {
        name: 'Yobe',
        isoCode: 'YO',
      },
      {
        name: 'Zamfara',
        isoCode: 'ZA',
      },
    ],
  },
  {
    name: 'Niue',
    isoCode: 'NU',
    states: [],
  },
  {
    name: 'Norfolk Island',
    isoCode: 'NF',
    states: [],
  },
  {
    name: 'North Korea',
    isoCode: 'KP',
    states: [],
  },
  {
    name: 'Northern Mariana Islands',
    isoCode: 'MP',
    states: [],
  },
  {
    name: 'Norway',
    isoCode: 'NO',
    states: [],
  },
  {
    name: 'Oman',
    isoCode: 'OM',
    states: [],
  },
  {
    name: 'Pakistan',
    isoCode: 'PK',
    states: [],
  },
  {
    name: 'Palau',
    isoCode: 'PW',
    states: [],
  },
  {
    name: 'Palestinian Territory Occupied',
    isoCode: 'PS',
    states: [],
  },
  {
    name: 'Panama',
    isoCode: 'PA',
    states: [],
  },
  {
    name: 'Papua new Guinea',
    isoCode: 'PG',
    states: [],
  },
  {
    name: 'Paraguay',
    isoCode: 'PY',
    states: [],
  },
  {
    name: 'Peru',
    isoCode: 'PE',
    states: [],
  },
  {
    name: 'Philippines',
    isoCode: 'PH',
    states: [
      {
        name: 'Abra',
        isoCode: 'ABR',
      },
      {
        name: 'Agusan del Norte',
        isoCode: 'AGN',
      },
      {
        name: 'Agusan del Sur',
        isoCode: 'AGS',
      },
      {
        name: 'Aklan',
        isoCode: 'AKL',
      },
      {
        name: 'Albay',
        isoCode: 'ALB',
      },
      {
        name: 'Antique',
        isoCode: 'ANT',
      },
      {
        name: 'Apayao',
        isoCode: 'APA',
      },
      {
        name: 'Aurora',
        isoCode: 'AUR',
      },
      {
        name: 'Autonomous Region in Muslim Mindanao',
        isoCode: '14',
      },
      {
        name: 'Basilan',
        isoCode: 'BAS',
      },
      {
        name: 'Bataan',
        isoCode: 'BAN',
      },
      {
        name: 'Batanes',
        isoCode: 'BTN',
      },
      {
        name: 'Batangas',
        isoCode: 'BTG',
      },
      {
        name: 'Benguet',
        isoCode: 'BEN',
      },
      {
        name: 'Bicol Region',
        isoCode: '05',
      },
      {
        name: 'Biliran',
        isoCode: 'BIL',
      },
      {
        name: 'Bohol',
        isoCode: 'BOH',
      },
      {
        name: 'Bukidnon',
        isoCode: 'BUK',
      },
      {
        name: 'Bulacan',
        isoCode: 'BUL',
      },
      {
        name: 'Cagayan',
        isoCode: 'CAG',
      },
      {
        name: 'Cagayan Valley',
        isoCode: '02',
      },
      {
        name: 'Calabarzon',
        isoCode: '40',
      },
      {
        name: 'Camarines Norte',
        isoCode: 'CAN',
      },
      {
        name: 'Camarines Sur',
        isoCode: 'CAS',
      },
      {
        name: 'Camiguin',
        isoCode: 'CAM',
      },
      {
        name: 'Capiz',
        isoCode: 'CAP',
      },
      {
        name: 'Caraga',
        isoCode: '13',
      },
      {
        name: 'Catanduanes',
        isoCode: 'CAT',
      },
      {
        name: 'Cavite',
        isoCode: 'CAV',
      },
      {
        name: 'Cebu',
        isoCode: 'CEB',
      },
      {
        name: 'Central Luzon',
        isoCode: '03',
      },
      {
        name: 'Central Visayas',
        isoCode: '07',
      },
      {
        name: 'Compostela Valley',
        isoCode: 'COM',
      },
      {
        name: 'Cordillera Administrative Region',
        isoCode: '15',
      },
      {
        name: 'Cotabato',
        isoCode: 'NCO',
      },
      {
        name: 'Davao del Norte',
        isoCode: 'DAV',
      },
      {
        name: 'Davao del Sur',
        isoCode: 'DAS',
      },
      {
        name: 'Davao Occidental',
        isoCode: 'DVO',
      },
      {
        name: 'Davao Oriental',
        isoCode: 'DAO',
      },
      {
        name: 'Davao Region',
        isoCode: '11',
      },
      {
        name: 'Dinagat Islands',
        isoCode: 'DIN',
      },
      {
        name: 'Eastern Samar',
        isoCode: 'EAS',
      },
      {
        name: 'Eastern Visayas',
        isoCode: '08',
      },
      {
        name: 'Guimaras',
        isoCode: 'GUI',
      },
      {
        name: 'Ifugao',
        isoCode: 'IFU',
      },
      {
        name: 'Ilocos Norte',
        isoCode: 'ILN',
      },
      {
        name: 'Ilocos Region',
        isoCode: '01',
      },
      {
        name: 'Ilocos Sur',
        isoCode: 'ILS',
      },
      {
        name: 'Iloilo',
        isoCode: 'ILI',
      },
      {
        name: 'Isabela',
        isoCode: 'ISA',
      },
      {
        name: 'Kalinga',
        isoCode: 'KAL',
      },
      {
        name: 'La Union',
        isoCode: 'LUN',
      },
      {
        name: 'Laguna',
        isoCode: 'LAG',
      },
      {
        name: 'Lanao del Norte',
        isoCode: 'LAN',
      },
      {
        name: 'Lanao del Sur',
        isoCode: 'LAS',
      },
      {
        name: 'Leyte',
        isoCode: 'LEY',
      },
      {
        name: 'Maguindanao',
        isoCode: 'MAG',
      },
      {
        name: 'Marinduque',
        isoCode: 'MAD',
      },
      {
        name: 'Masbate',
        isoCode: 'MAS',
      },
      {
        name: 'Metro Manila',
        isoCode: 'NCR',
      },
      {
        name: 'Mimaropa',
        isoCode: '41',
      },
      {
        name: 'Misamis Occidental',
        isoCode: 'MSC',
      },
      {
        name: 'Misamis Oriental',
        isoCode: 'MSR',
      },
      {
        name: 'Mountain Province',
        isoCode: 'MOU',
      },
      {
        name: 'Negros Occidental',
        isoCode: 'NEC',
      },
      {
        name: 'Negros Oriental',
        isoCode: 'NER',
      },
      {
        name: 'Northern Mindanao',
        isoCode: '10',
      },
      {
        name: 'Northern Samar',
        isoCode: 'NSA',
      },
      {
        name: 'Nueva Ecija',
        isoCode: 'NUE',
      },
      {
        name: 'Nueva Vizcaya',
        isoCode: 'NUV',
      },
      {
        name: 'Occidental Mindoro',
        isoCode: 'MDC',
      },
      {
        name: 'Oriental Mindoro',
        isoCode: 'MDR',
      },
      {
        name: 'Palawan',
        isoCode: 'PLW',
      },
      {
        name: 'Pampanga',
        isoCode: 'PAM',
      },
      {
        name: 'Pangasinan',
        isoCode: 'PAN',
      },
      {
        name: 'Quezon',
        isoCode: 'QUE',
      },
      {
        name: 'Quirino',
        isoCode: 'QUI',
      },
      {
        name: 'Rizal',
        isoCode: 'RIZ',
      },
      {
        name: 'Romblon',
        isoCode: 'ROM',
      },
      {
        name: 'Sarangani',
        isoCode: 'SAR',
      },
      {
        name: 'Siquijor',
        isoCode: 'SIG',
      },
      {
        name: 'Soccsksargen',
        isoCode: '12',
      },
      {
        name: 'Sorsogon',
        isoCode: 'SOR',
      },
      {
        name: 'South Cotabato',
        isoCode: 'SCO',
      },
      {
        name: 'Southern Leyte',
        isoCode: 'SLE',
      },
      {
        name: 'Sultan Kudarat',
        isoCode: 'SUK',
      },
      {
        name: 'Sulu',
        isoCode: 'SLU',
      },
      {
        name: 'Surigao del Norte',
        isoCode: 'SUN',
      },
      {
        name: 'Surigao del Sur',
        isoCode: 'SUR',
      },
      {
        name: 'Tarlac',
        isoCode: 'TAR',
      },
      {
        name: 'Tawi-Tawi',
        isoCode: 'TAW',
      },
      {
        name: 'Western Visayas',
        isoCode: '06',
      },
      {
        name: 'Zambales',
        isoCode: 'ZMB',
      },
      {
        name: 'Zamboanga del Norte',
        isoCode: 'ZAN',
      },
      {
        name: 'Zamboanga del Sur',
        isoCode: 'ZAS',
      },
      {
        name: 'Zamboanga Peninsula',
        isoCode: '09',
      },
      {
        name: 'Zamboanga Sibugay',
        isoCode: 'ZSI',
      },
    ],
  },
  {
    name: 'Pitcairn Island',
    isoCode: 'PN',
    states: [],
  },
  {
    name: 'Poland',
    isoCode: 'PL',
    states: [],
  },
  {
    name: 'Portugal',
    isoCode: 'PT',
    states: [],
  },
  {
    name: 'Puerto Rico',
    isoCode: 'PR',
    states: [],
  },
  {
    name: 'Qatar',
    isoCode: 'QA',
    states: [],
  },
  {
    name: 'Reunion',
    isoCode: 'RE',
    states: [],
  },
  {
    name: 'Romania',
    isoCode: 'RO',
    states: [],
  },
  {
    name: 'Russia',
    isoCode: 'RU',
    states: [
      {
        name: 'Altai Krai',
        isoCode: 'ALT',
      },
      {
        name: 'Altai Republic',
        isoCode: 'AL',
      },
      {
        name: 'Amur Oblast',
        isoCode: 'AMU',
      },
      {
        name: 'Arkhangelsk',
        isoCode: 'ARK',
      },
      {
        name: 'Astrakhan Oblast',
        isoCode: 'AST',
      },
      {
        name: 'Belgorod Oblast',
        isoCode: 'BEL',
      },
      {
        name: 'Bryansk Oblast',
        isoCode: 'BRY',
      },
      {
        name: 'Chechen Republic',
        isoCode: 'CE',
      },
      {
        name: 'Chelyabinsk Oblast',
        isoCode: 'CHE',
      },
      {
        name: 'Chukotka Autonomous Okrug',
        isoCode: 'CHU',
      },
      {
        name: 'Chuvash Republic',
        isoCode: 'CU',
      },
      {
        name: 'Irkutsk',
        isoCode: 'IRK',
      },
      {
        name: 'Ivanovo Oblast',
        isoCode: 'IVA',
      },
      {
        name: 'Jewish Autonomous Oblast',
        isoCode: 'YEV',
      },
      {
        name: 'Kabardino-Balkar Republic',
        isoCode: 'KB',
      },
      {
        name: 'Kaliningrad',
        isoCode: 'KGD',
      },
      {
        name: 'Kaluga Oblast',
        isoCode: 'KLU',
      },
      {
        name: 'Kamchatka Krai',
        isoCode: 'KAM',
      },
      {
        name: 'Karachay-Cherkess Republic',
        isoCode: 'KC',
      },
      {
        name: 'Kemerovo Oblast',
        isoCode: 'KEM',
      },
      {
        name: 'Khabarovsk Krai',
        isoCode: 'KHA',
      },
      {
        name: 'Khanty-Mansi Autonomous Okrug',
        isoCode: 'KHM',
      },
      {
        name: 'Kirov Oblast',
        isoCode: 'KIR',
      },
      {
        name: 'Komi Republic',
        isoCode: 'KO',
      },
      {
        name: 'Kostroma Oblast',
        isoCode: 'KOS',
      },
      {
        name: 'Krasnodar Krai',
        isoCode: 'KDA',
      },
      {
        name: 'Krasnoyarsk Krai',
        isoCode: 'KYA',
      },
      {
        name: 'Kurgan Oblast',
        isoCode: 'KGN',
      },
      {
        name: 'Kursk Oblast',
        isoCode: 'KRS',
      },
      {
        name: 'Leningrad Oblast',
        isoCode: 'LEN',
      },
      {
        name: 'Lipetsk Oblast',
        isoCode: 'LIP',
      },
      {
        name: 'Magadan Oblast',
        isoCode: 'MAG',
      },
      {
        name: 'Mari El Republic',
        isoCode: 'ME',
      },
      {
        name: 'Moscow',
        isoCode: 'MOW',
      },
      {
        name: 'Moscow Oblast',
        isoCode: 'MOS',
      },
      {
        name: 'Murmansk Oblast',
        isoCode: 'MUR',
      },
      {
        name: 'Nenets Autonomous Okrug',
        isoCode: 'NEN',
      },
      {
        name: 'Nizhny Novgorod Oblast',
        isoCode: 'NIZ',
      },
      {
        name: 'Novgorod Oblast',
        isoCode: 'NGR',
      },
      {
        name: 'Novosibirsk',
        isoCode: 'NVS',
      },
      {
        name: 'Omsk Oblast',
        isoCode: 'OMS',
      },
      {
        name: 'Orenburg Oblast',
        isoCode: 'ORE',
      },
      {
        name: 'Oryol Oblast',
        isoCode: 'ORL',
      },
      {
        name: 'Penza Oblast',
        isoCode: 'PNZ',
      },
      {
        name: 'Perm Krai',
        isoCode: 'PER',
      },
      {
        name: 'Primorsky Krai',
        isoCode: 'PRI',
      },
      {
        name: 'Pskov Oblast',
        isoCode: 'PSK',
      },
      {
        name: 'Republic of Adygea',
        isoCode: 'AD',
      },
      {
        name: 'Republic of Bashkortostan',
        isoCode: 'BA',
      },
      {
        name: 'Republic of Buryatia',
        isoCode: 'BU',
      },
      {
        name: 'Republic of Dagestan',
        isoCode: 'DA',
      },
      {
        name: 'Republic of Ingushetia',
        isoCode: 'IN',
      },
      {
        name: 'Republic of Kalmykia',
        isoCode: 'KL',
      },
      {
        name: 'Republic of Karelia',
        isoCode: 'KR',
      },
      {
        name: 'Republic of Khakassia',
        isoCode: 'KK',
      },
      {
        name: 'Republic of Mordovia',
        isoCode: 'MO',
      },
      {
        name: 'Republic of North Ossetia-Alania',
        isoCode: 'SE',
      },
      {
        name: 'Republic of Tatarstan',
        isoCode: 'TA',
      },
      {
        name: 'Rostov Oblast',
        isoCode: 'ROS',
      },
      {
        name: 'Ryazan Oblast',
        isoCode: 'RYA',
      },
      {
        name: 'Saint Petersburg',
        isoCode: 'SPE',
      },
      {
        name: 'Sakha Republic',
        isoCode: 'SA',
      },
      {
        name: 'Sakhalin',
        isoCode: 'SAK',
      },
      {
        name: 'Samara Oblast',
        isoCode: 'SAM',
      },
      {
        name: 'Saratov Oblast',
        isoCode: 'SAR',
      },
      {
        name: 'Sevastopol',
        isoCode: 'UA-40',
      },
      {
        name: 'Smolensk Oblast',
        isoCode: 'SMO',
      },
      {
        name: 'Stavropol Krai',
        isoCode: 'STA',
      },
      {
        name: 'Sverdlovsk',
        isoCode: 'SVE',
      },
      {
        name: 'Tambov Oblast',
        isoCode: 'TAM',
      },
      {
        name: 'Tomsk Oblast',
        isoCode: 'TOM',
      },
      {
        name: 'Tula Oblast',
        isoCode: 'TUL',
      },
      {
        name: 'Tuva Republic',
        isoCode: 'TY',
      },
      {
        name: 'Tver Oblast',
        isoCode: 'TVE',
      },
      {
        name: 'Tyumen Oblast',
        isoCode: 'TYU',
      },
      {
        name: 'Udmurt Republic',
        isoCode: 'UD',
      },
      {
        name: 'Ulyanovsk Oblast',
        isoCode: 'ULY',
      },
      {
        name: 'Vladimir Oblast',
        isoCode: 'VLA',
      },
      {
        name: 'Volgograd Oblast',
        isoCode: 'VGG',
      },
      {
        name: 'Vologda Oblast',
        isoCode: 'VLG',
      },
      {
        name: 'Voronezh Oblast',
        isoCode: 'VOR',
      },
      {
        name: 'Yamalo-Nenets Autonomous Okrug',
        isoCode: 'YAN',
      },
      {
        name: 'Yaroslavl Oblast',
        isoCode: 'YAR',
      },
      {
        name: 'Zabaykalsky Krai',
        isoCode: 'ZAB',
      },
    ],
  },
  {
    name: 'Rwanda',
    isoCode: 'RW',
    states: [],
  },
  {
    name: 'Saint Helena',
    isoCode: 'SH',
    states: [],
  },
  {
    name: 'Saint Kitts And Nevis',
    isoCode: 'KN',
    states: [],
  },
  {
    name: 'Saint Lucia',
    isoCode: 'LC',
    states: [],
  },
  {
    name: 'Saint Pierre and Miquelon',
    isoCode: 'PM',
    states: [],
  },
  {
    name: 'Saint Vincent And The Grenadines',
    isoCode: 'VC',
    states: [],
  },
  {
    name: 'Saint-Barthelemy',
    isoCode: 'BL',
    states: [],
  },
  {
    name: 'Saint-Martin (French part)',
    isoCode: 'MF',
    states: [],
  },
  {
    name: 'Samoa',
    isoCode: 'WS',
    states: [],
  },
  {
    name: 'San Marino',
    isoCode: 'SM',
    states: [],
  },
  {
    name: 'Sao Tome and Principe',
    isoCode: 'ST',
    states: [],
  },
  {
    name: 'Saudi Arabia',
    isoCode: 'SA',
    states: [],
  },
  {
    name: 'Senegal',
    isoCode: 'SN',
    states: [],
  },
  {
    name: 'Serbia',
    isoCode: 'RS',
    states: [],
  },
  {
    name: 'Seychelles',
    isoCode: 'SC',
    states: [],
  },
  {
    name: 'Sierra Leone',
    isoCode: 'SL',
    states: [],
  },
  {
    name: 'Singapore',
    isoCode: 'SG',
    states: [],
  },
  {
    name: 'Sint Maarten (Dutch part)',
    isoCode: 'SX',
    states: [],
  },
  {
    name: 'Slovakia',
    isoCode: 'SK',
    states: [],
  },
  {
    name: 'Slovenia',
    isoCode: 'SI',
    states: [],
  },
  {
    name: 'Solomon Islands',
    isoCode: 'SB',
    states: [],
  },
  {
    name: 'Somalia',
    isoCode: 'SO',
    states: [],
  },
  {
    name: 'South Africa',
    isoCode: 'ZA',
    states: [
      {
        name: 'Eastern Cape',
        isoCode: 'EC',
      },
      {
        name: 'Free State',
        isoCode: 'FS',
      },
      {
        name: 'Gauteng',
        isoCode: 'GP',
      },
      {
        name: 'KwaZulu-Natal',
        isoCode: 'KZN',
      },
      {
        name: 'Limpopo',
        isoCode: 'LP',
      },
      {
        name: 'Mpumalanga',
        isoCode: 'MP',
      },
      {
        name: 'North West',
        isoCode: 'NW',
      },
      {
        name: 'Northern Cape',
        isoCode: 'NC',
      },
      {
        name: 'Western Cape',
        isoCode: 'WC',
      },
    ],
  },
  {
    name: 'South Georgia',
    isoCode: 'GS',
    states: [],
  },
  {
    name: 'South Korea',
    isoCode: 'KR',
    states: [],
  },
  {
    name: 'South Sudan',
    isoCode: 'SS',
    states: [],
  },
  {
    name: 'Spain',
    isoCode: 'ES',
    states: [],
  },
  {
    name: 'Sri Lanka',
    isoCode: 'LK',
    states: [],
  },
  {
    name: 'Sudan',
    isoCode: 'SD',
    states: [],
  },
  {
    name: 'Suriname',
    isoCode: 'SR',
    states: [],
  },
  {
    name: 'Svalbard And Jan Mayen Islands',
    isoCode: 'SJ',
    states: [],
  },
  {
    name: 'Swaziland',
    isoCode: 'SZ',
    states: [],
  },
  {
    name: 'Sweden',
    isoCode: 'SE',
    states: [],
  },
  {
    name: 'Switzerland',
    isoCode: 'CH',
    states: [],
  },
  {
    name: 'Syria',
    isoCode: 'SY',
    states: [],
  },
  {
    name: 'Taiwan',
    isoCode: 'TW',
    states: [],
  },
  {
    name: 'Tajikistan',
    isoCode: 'TJ',
    states: [],
  },
  {
    name: 'Tanzania',
    isoCode: 'TZ',
    states: [],
  },
  {
    name: 'Thailand',
    isoCode: 'TH',
    states: [],
  },
  {
    name: 'The Bahamas',
    isoCode: 'BS',
    states: [],
  },
  {
    name: 'Togo',
    isoCode: 'TG',
    states: [],
  },
  {
    name: 'Tokelau',
    isoCode: 'TK',
    states: [],
  },
  {
    name: 'Tonga',
    isoCode: 'TO',
    states: [],
  },
  {
    name: 'Trinidad And Tobago',
    isoCode: 'TT',
    states: [],
  },
  {
    name: 'Tunisia',
    isoCode: 'TN',
    states: [],
  },
  {
    name: 'Turkey',
    isoCode: 'TR',
    states: [],
  },
  {
    name: 'Turkmenistan',
    isoCode: 'TM',
    states: [],
  },
  {
    name: 'Turks And Caicos Islands',
    isoCode: 'TC',
    states: [],
  },
  {
    name: 'Tuvalu',
    isoCode: 'TV',
    states: [],
  },
  {
    name: 'Uganda',
    isoCode: 'UG',
    states: [],
  },
  {
    name: 'Ukraine',
    isoCode: 'UA',
    states: [],
  },
  {
    name: 'United Arab Emirates',
    isoCode: 'AE',
    states: [],
  },
  {
    name: 'United Kingdom',
    isoCode: 'GB',
    states: [],
  },
  {
    name: 'United States',
    isoCode: 'US',
    states: [
      {
        name: 'Alabama',
        isoCode: 'AL',
      },
      {
        name: 'Alaska',
        isoCode: 'AK',
      },
      {
        name: 'American Samoa',
        isoCode: 'AS',
      },
      {
        name: 'Arizona',
        isoCode: 'AZ',
      },
      {
        name: 'Arkansas',
        isoCode: 'AR',
      },
      {
        name: 'Baker Island',
        isoCode: 'UM-81',
      },
      {
        name: 'California',
        isoCode: 'CA',
      },
      {
        name: 'Colorado',
        isoCode: 'CO',
      },
      {
        name: 'Connecticut',
        isoCode: 'CT',
      },
      {
        name: 'Delaware',
        isoCode: 'DE',
      },
      {
        name: 'District of Columbia',
        isoCode: 'DC',
      },
      {
        name: 'Florida',
        isoCode: 'FL',
      },
      {
        name: 'Georgia',
        isoCode: 'GA',
      },
      {
        name: 'Guam',
        isoCode: 'GU',
      },
      {
        name: 'Hawaii',
        isoCode: 'HI',
      },
      {
        name: 'Howland Island',
        isoCode: 'UM-84',
      },
      {
        name: 'Idaho',
        isoCode: 'ID',
      },
      {
        name: 'Illinois',
        isoCode: 'IL',
      },
      {
        name: 'Indiana',
        isoCode: 'IN',
      },
      {
        name: 'Iowa',
        isoCode: 'IA',
      },
      {
        name: 'Jarvis Island',
        isoCode: 'UM-86',
      },
      {
        name: 'Johnston Atoll',
        isoCode: 'UM-67',
      },
      {
        name: 'Kansas',
        isoCode: 'KS',
      },
      {
        name: 'Kentucky',
        isoCode: 'KY',
      },
      {
        name: 'Kingman Reef',
        isoCode: 'UM-89',
      },
      {
        name: 'Louisiana',
        isoCode: 'LA',
      },
      {
        name: 'Maine',
        isoCode: 'ME',
      },
      {
        name: 'Maryland',
        isoCode: 'MD',
      },
      {
        name: 'Massachusetts',
        isoCode: 'MA',
      },
      {
        name: 'Michigan',
        isoCode: 'MI',
      },
      {
        name: 'Midway Atoll',
        isoCode: 'UM-71',
      },
      {
        name: 'Minnesota',
        isoCode: 'MN',
      },
      {
        name: 'Mississippi',
        isoCode: 'MS',
      },
      {
        name: 'Missouri',
        isoCode: 'MO',
      },
      {
        name: 'Montana',
        isoCode: 'MT',
      },
      {
        name: 'Navassa Island',
        isoCode: 'UM-76',
      },
      {
        name: 'Nebraska',
        isoCode: 'NE',
      },
      {
        name: 'Nevada',
        isoCode: 'NV',
      },
      {
        name: 'New Hampshire',
        isoCode: 'NH',
      },
      {
        name: 'New Jersey',
        isoCode: 'NJ',
      },
      {
        name: 'New Mexico',
        isoCode: 'NM',
      },
      {
        name: 'New York',
        isoCode: 'NY',
      },
      {
        name: 'North Carolina',
        isoCode: 'NC',
      },
      {
        name: 'North Dakota',
        isoCode: 'ND',
      },
      {
        name: 'Northern Mariana Islands',
        isoCode: 'MP',
      },
      {
        name: 'Ohio',
        isoCode: 'OH',
      },
      {
        name: 'Oklahoma',
        isoCode: 'OK',
      },
      {
        name: 'Oregon',
        isoCode: 'OR',
      },
      {
        name: 'Palmyra Atoll',
        isoCode: 'UM-95',
      },
      {
        name: 'Pennsylvania',
        isoCode: 'PA',
      },
      {
        name: 'Puerto Rico',
        isoCode: 'PR',
      },
      {
        name: 'Rhode Island',
        isoCode: 'RI',
      },
      {
        name: 'South Carolina',
        isoCode: 'SC',
      },
      {
        name: 'South Dakota',
        isoCode: 'SD',
      },
      {
        name: 'Tennessee',
        isoCode: 'TN',
      },
      {
        name: 'Texas',
        isoCode: 'TX',
      },
      {
        name: 'United States Minor Outlying Islands',
        isoCode: 'UM',
      },
      {
        name: 'United States Virgin Islands',
        isoCode: 'VI',
      },
      {
        name: 'Utah',
        isoCode: 'UT',
      },
      {
        name: 'Vermont',
        isoCode: 'VT',
      },
      {
        name: 'Virginia',
        isoCode: 'VA',
      },
      {
        name: 'Wake Island',
        isoCode: 'UM-79',
      },
      {
        name: 'Washington',
        isoCode: 'WA',
      },
      {
        name: 'West Virginia',
        isoCode: 'WV',
      },
      {
        name: 'Wisconsin',
        isoCode: 'WI',
      },
      {
        name: 'Wyoming',
        isoCode: 'WY',
      },
    ],
  },
  {
    name: 'United States Minor Outlying Islands',
    isoCode: 'UM',
    states: [],
  },
  {
    name: 'Uruguay',
    isoCode: 'UY',
    states: [],
  },
  {
    name: 'Uzbekistan',
    isoCode: 'UZ',
    states: [],
  },
  {
    name: 'Vanuatu',
    isoCode: 'VU',
    states: [],
  },
  {
    name: 'Vatican City State (Holy See)',
    isoCode: 'VA',
    states: [],
  },
  {
    name: 'Venezuela',
    isoCode: 'VE',
    states: [],
  },
  {
    name: 'Vietnam',
    isoCode: 'VN',
    states: [],
  },
  {
    name: 'Virgin Islands (British)',
    isoCode: 'VG',
    states: [],
  },
  {
    name: 'Virgin Islands (US)',
    isoCode: 'VI',
    states: [],
  },
  {
    name: 'Wallis And Futuna Islands',
    isoCode: 'WF',
    states: [],
  },
  {
    name: 'Western Sahara',
    isoCode: 'EH',
    states: [],
  },
  {
    name: 'Yemen',
    isoCode: 'YE',
    states: [],
  },
  {
    name: 'Zambia',
    isoCode: 'ZM',
    states: [],
  },
  {
    name: 'Zimbabwe',
    isoCode: 'ZW',
    states: [],
  },
];

// Mapping of ISO codes or common country names and their ISO codes
const CountryNameMapping = {
  afghanistan: 'AF',
  af: 'AF',
  albania: 'AL',
  al: 'AL',
  algeria: 'DZ',
  dz: 'DZ',
  'american samoa': 'AS',
  as: 'AS',
  andorra: 'AD',
  ad: 'AD',
  angola: 'AO',
  ao: 'AO',
  anguilla: 'AI',
  ai: 'AI',
  antarctica: 'AQ',
  aq: 'AQ',
  'antigua and barbuda': 'AG',
  ag: 'AG',
  argentina: 'AR',
  ar: 'AR',
  armenia: 'AM',
  am: 'AM',
  aruba: 'AW',
  aw: 'AW',
  australia: 'AU',
  au: 'AU',
  austria: 'AT',
  at: 'AT',
  azerbaijan: 'AZ',
  az: 'AZ',
  bahamas: 'BS',
  bs: 'BS',
  bahrain: 'BH',
  bh: 'BH',
  bangladesh: 'BD',
  bd: 'BD',
  barbados: 'BB',
  bb: 'BB',
  belarus: 'BY',
  by: 'BY',
  belgium: 'BE',
  be: 'BE',
  belize: 'BZ',
  bz: 'BZ',
  benin: 'BJ',
  bj: 'BJ',
  bermuda: 'BM',
  bm: 'BM',
  bhutan: 'BT',
  bt: 'BT',
  bolivia: 'BO',
  bo: 'BO',
  'bosnia and herzegovina': 'BA',
  ba: 'BA',
  botswana: 'BW',
  bw: 'BW',
  'bouvet island': 'BV',
  bv: 'BV',
  brazil: 'BR',
  br: 'BR',
  'british indian ocean territory': 'IO',
  io: 'IO',
  'brunei darussalam': 'BN',
  bn: 'BN',
  bulgaria: 'BG',
  bg: 'BG',
  'burkina faso': 'BF',
  bf: 'BF',
  burundi: 'BI',
  bi: 'BI',
  cambodia: 'KH',
  kh: 'KH',
  cameroon: 'CM',
  cm: 'CM',
  canada: 'CA',
  ca: 'CA',
  'cape verde': 'CV',
  cv: 'CV',
  'cayman islands': 'KY',
  ky: 'KY',
  'central african republic': 'CF',
  cf: 'CF',
  chad: 'TD',
  td: 'TD',
  chile: 'CL',
  cl: 'CL',
  "people's republic of china": 'CN',
  china: 'CN',
  cn: 'CN',
  'christmas island': 'CX',
  cx: 'CX',
  'cocos (keeling) islands': 'CC',
  cc: 'CC',
  colombia: 'CO',
  co: 'CO',
  comoros: 'KM',
  km: 'KM',
  'republic of the congo': 'CG',
  congo: 'CD',
  cg: 'CG',
  'democratic republic of the congo': 'CD',
  cd: 'CD',
  'cook islands': 'CK',
  ck: 'CK',
  'costa rica': 'CR',
  cr: 'CR',
  "cote d'ivoire": 'CI',
  "côte d'ivoire": 'CI',
  'ivory coast': 'CI',
  ci: 'CI',
  croatia: 'HR',
  hr: 'HR',
  cuba: 'CU',
  cu: 'CU',
  cyprus: 'CY',
  cy: 'CY',
  'czech republic': 'CZ',
  czechia: 'CZ',
  cz: 'CZ',
  denmark: 'DK',
  dk: 'DK',
  djibouti: 'DJ',
  dj: 'DJ',
  dominica: 'DM',
  dm: 'DM',
  'dominican republic': 'DO',
  do: 'DO',
  ecuador: 'EC',
  ec: 'EC',
  egypt: 'EG',
  eg: 'EG',
  'el salvador': 'SV',
  sv: 'SV',
  'equatorial guinea': 'GQ',
  gq: 'GQ',
  eritrea: 'ER',
  er: 'ER',
  estonia: 'EE',
  ee: 'EE',
  ethiopia: 'ET',
  et: 'ET',
  'falkland islands (malvinas)': 'FK',
  fk: 'FK',
  'faroe islands': 'FO',
  fo: 'FO',
  fiji: 'FJ',
  fj: 'FJ',
  finland: 'FI',
  fi: 'FI',
  france: 'FR',
  fr: 'FR',
  'french guiana': 'GF',
  gf: 'GF',
  'french polynesia': 'PF',
  pf: 'PF',
  'french southern territories': 'TF',
  tf: 'TF',
  gabon: 'GA',
  ga: 'GA',
  'republic of the gambia': 'GM',
  'the gambia': 'GM',
  gambia: 'GM',
  gm: 'GM',
  georgia: 'GE',
  ge: 'GE',
  germany: 'DE',
  de: 'DE',
  ghana: 'GH',
  gh: 'GH',
  gibraltar: 'GI',
  gi: 'GI',
  greece: 'GR',
  gr: 'GR',
  greenland: 'GL',
  gl: 'GL',
  grenada: 'GD',
  gd: 'GD',
  guadeloupe: 'GP',
  gp: 'GP',
  guam: 'GU',
  gu: 'GU',
  guatemala: 'GT',
  gt: 'GT',
  guinea: 'GN',
  gn: 'GN',
  'guinea-bissau': 'GW',
  gw: 'GW',
  guyana: 'GY',
  gy: 'GY',
  haiti: 'HT',
  ht: 'HT',
  'heard island and mcdonald islands': 'HM',
  hm: 'HM',
  'holy see (vatican city state)': 'VA',
  va: 'VA',
  honduras: 'HN',
  hn: 'HN',
  'hong kong': 'HK',
  hk: 'HK',
  hungary: 'HU',
  hu: 'HU',
  iceland: 'IS',
  is: 'IS',
  india: 'IN',
  in: 'IN',
  indonesia: 'ID',
  id: 'ID',
  'islamic republic of iran': 'IR',
  iran: 'IR',
  ir: 'IR',
  iraq: 'IQ',
  iq: 'IQ',
  ireland: 'IE',
  ie: 'IE',
  israel: 'IL',
  il: 'IL',
  italy: 'IT',
  it: 'IT',
  jamaica: 'JM',
  jm: 'JM',
  japan: 'JP',
  jp: 'JP',
  jordan: 'JO',
  jo: 'JO',
  kazakhstan: 'KZ',
  kz: 'KZ',
  kenya: 'KE',
  ke: 'KE',
  kiribati: 'KI',
  ki: 'KI',
  'north korea': 'KP',
  kp: 'KP',
  'south korea': 'KR',
  'korea, republic of': 'KR',
  'republic of korea': 'KR',
  kr: 'KR',
  kuwait: 'KW',
  kw: 'KW',
  kyrgyzstan: 'KG',
  kg: 'KG',
  "lao people's democratic republic": 'LA',
  la: 'LA',
  latvia: 'LV',
  lv: 'LV',
  lebanon: 'LB',
  lb: 'LB',
  lesotho: 'LS',
  ls: 'LS',
  liberia: 'LR',
  lr: 'LR',
  libya: 'LY',
  ly: 'LY',
  liechtenstein: 'LI',
  li: 'LI',
  lithuania: 'LT',
  lt: 'LT',
  luxembourg: 'LU',
  lu: 'LU',
  macao: 'MO',
  mo: 'MO',
  madagascar: 'MG',
  mg: 'MG',
  malawi: 'MW',
  mw: 'MW',
  malaysia: 'MY',
  my: 'MY',
  maldives: 'MV',
  mv: 'MV',
  mali: 'ML',
  ml: 'ML',
  malta: 'MT',
  mt: 'MT',
  'marshall islands': 'MH',
  mh: 'MH',
  martinique: 'MQ',
  mq: 'MQ',
  mauritania: 'MR',
  mr: 'MR',
  mauritius: 'MU',
  mu: 'MU',
  mayotte: 'YT',
  yt: 'YT',
  mexico: 'MX',
  mx: 'MX',
  'micronesia, federated states of': 'FM',
  fm: 'FM',
  'moldova, republic of': 'MD',
  md: 'MD',
  monaco: 'MC',
  mc: 'MC',
  mongolia: 'MN',
  mn: 'MN',
  montserrat: 'MS',
  ms: 'MS',
  morocco: 'MA',
  ma: 'MA',
  mozambique: 'MZ',
  mz: 'MZ',
  myanmar: 'MM',
  mm: 'MM',
  namibia: 'NA',
  na: 'NA',
  nauru: 'NR',
  nr: 'NR',
  nepal: 'NP',
  np: 'NP',
  netherlands: 'NL',
  'the netherlands': 'NL',
  'netherlands (kingdom of the)': 'NL',
  nl: 'NL',
  'new caledonia': 'NC',
  nc: 'NC',
  'new zealand': 'NZ',
  nz: 'NZ',
  nicaragua: 'NI',
  ni: 'NI',
  niger: 'NE',
  ne: 'NE',
  nigeria: 'NG',
  ng: 'NG',
  niue: 'NU',
  nu: 'NU',
  'norfolk island': 'NF',
  nf: 'NF',
  'the republic of north macedonia': 'MK',
  'north macedonia': 'MK',
  mk: 'MK',
  'northern mariana islands': 'MP',
  mp: 'MP',
  norway: 'NO',
  no: 'NO',
  oman: 'OM',
  om: 'OM',
  pakistan: 'PK',
  pk: 'PK',
  palau: 'PW',
  pw: 'PW',
  'state of palestine': 'PS',
  palestine: 'PS',
  ps: 'PS',
  panama: 'PA',
  pa: 'PA',
  'papua new guinea': 'PG',
  pg: 'PG',
  paraguay: 'PY',
  py: 'PY',
  peru: 'PE',
  pe: 'PE',
  philippines: 'PH',
  ph: 'PH',
  pitcairn: 'PN',
  'pitcairn islands': 'PN',
  pn: 'PN',
  poland: 'PL',
  pl: 'PL',
  portugal: 'PT',
  pt: 'PT',
  'puerto rico': 'PR',
  pr: 'PR',
  qatar: 'QA',
  qa: 'QA',
  reunion: 'RE',
  re: 'RE',
  romania: 'RO',
  ro: 'RO',
  'russian federation': 'RU',
  russia: 'RU',
  ru: 'RU',
  rwanda: 'RW',
  rw: 'RW',
  'saint helena': 'SH',
  sh: 'SH',
  'saint kitts and nevis': 'KN',
  kn: 'KN',
  'saint lucia': 'LC',
  lc: 'LC',
  'saint pierre and miquelon': 'PM',
  pm: 'PM',
  'saint vincent and the grenadines': 'VC',
  vc: 'VC',
  samoa: 'WS',
  ws: 'WS',
  'san marino': 'SM',
  sm: 'SM',
  'sao tome and principe': 'ST',
  st: 'ST',
  'saudi arabia': 'SA',
  sa: 'SA',
  senegal: 'SN',
  sn: 'SN',
  seychelles: 'SC',
  sc: 'SC',
  'sierra leone': 'SL',
  sl: 'SL',
  singapore: 'SG',
  sg: 'SG',
  slovakia: 'SK',
  sk: 'SK',
  slovenia: 'SI',
  si: 'SI',
  'solomon islands': 'SB',
  sb: 'SB',
  somalia: 'SO',
  so: 'SO',
  'south africa': 'ZA',
  za: 'ZA',
  'south georgia and the south sandwich islands': 'GS',
  gs: 'GS',
  spain: 'ES',
  es: 'ES',
  'sri lanka': 'LK',
  lk: 'LK',
  sudan: 'SD',
  sd: 'SD',
  suriname: 'SR',
  sr: 'SR',
  'svalbard and jan mayen': 'SJ',
  sj: 'SJ',
  eswatini: 'SZ',
  sz: 'SZ',
  sweden: 'SE',
  se: 'SE',
  switzerland: 'CH',
  ch: 'CH',
  'syrian arab republic': 'SY',
  sy: 'SY',
  'taiwan, province of china': 'TW',
  taiwan: 'TW',
  tw: 'TW',
  tajikistan: 'TJ',
  tj: 'TJ',
  'united republic of tanzania': 'TZ',
  tanzania: 'TZ',
  tz: 'TZ',
  thailand: 'TH',
  th: 'TH',
  'timor-leste': 'TL',
  tl: 'TL',
  togo: 'TG',
  tg: 'TG',
  tokelau: 'TK',
  tk: 'TK',
  tonga: 'TO',
  to: 'TO',
  'trinidad and tobago': 'TT',
  tt: 'TT',
  tunisia: 'TN',
  tn: 'TN',
  türkiye: 'TR',
  turkey: 'TR',
  tr: 'TR',
  turkmenistan: 'TM',
  tm: 'TM',
  'turks and caicos islands': 'TC',
  tc: 'TC',
  tuvalu: 'TV',
  tv: 'TV',
  uganda: 'UG',
  ug: 'UG',
  ukraine: 'UA',
  ua: 'UA',
  'united arab emirates': 'AE',
  uae: 'AE',
  ae: 'AE',
  'united kingdom': 'GB',
  uk: 'GB',
  'great britain': 'GB',
  gb: 'GB',
  'united states of america': 'US',
  'united states': 'US',
  usa: 'US',
  'u.s.a.': 'US',
  us: 'US',
  'u.s.': 'US',
  'united states minor outlying islands': 'UM',
  um: 'UM',
  uruguay: 'UY',
  uy: 'UY',
  uzbekistan: 'UZ',
  uz: 'UZ',
  vanuatu: 'VU',
  vu: 'VU',
  venezuela: 'VE',
  ve: 'VE',
  vietnam: 'VN',
  vn: 'VN',
  'virgin islands, british': 'VG',
  vg: 'VG',
  'virgin islands, u.s.': 'VI',
  vi: 'VI',
  'wallis and futuna': 'WF',
  wf: 'WF',
  'western sahara': 'EH',
  eh: 'EH',
  yemen: 'YE',
  ye: 'YE',
  zambia: 'ZM',
  zm: 'ZM',
  zimbabwe: 'ZW',
  zw: 'ZW',
  'åland islands': 'AX',
  'aland islands': 'AX',
  ax: 'AX',
  'bonaire, sint eustatius and saba': 'BQ',
  bq: 'BQ',
  curaçao: 'CW',
  cw: 'CW',
  guernsey: 'GG',
  gg: 'GG',
  'isle of man': 'IM',
  im: 'IM',
  jersey: 'JE',
  je: 'JE',
  montenegro: 'ME',
  me: 'ME',
  'saint barthélemy': 'BL',
  bl: 'BL',
  'saint martin (french part)': 'MF',
  mf: 'MF',
  serbia: 'RS',
  rs: 'RS',
  'sint maarten (dutch part)': 'SX',
  sx: 'SX',
  'south sudan': 'SS',
  ss: 'SS',
  kosovo: 'XK',
  xk: 'XK',
};

/**
 * Given a country's name or country code, return country code.
 */
export const getCountryCodeFromNameOrCode = (
  countryName: Maybe<string>,
): Maybe<string> => {
  if (!countryName) {
    return countryName;
  }
  return CountryNameMapping[countryName.toLowerCase()] || countryName;
};

/**
 * Given a country code or country name, return the list of states for that country.
 */
export const getStatesFromCountry = (
  countryNameOrCode: Maybe<string>,
): CountryState[] => {
  const value = getCountryCodeFromNameOrCode(countryNameOrCode);
  if (!value || !statesByCountry[value]) {
    return [];
  }
  return statesByCountry[value];
};

export const getCountryCodeFromLanguage = (): string | null => {
  const maybeCountryCode = navigator.language?.split('-')?.[1];
  if (
    !maybeCountryCode ||
    !CountryNameMapping[maybeCountryCode.toLowerCase()]
  ) {
    return null;
  }
  return CountryNameMapping[maybeCountryCode.toLowerCase()];
};

export const statesByCountry = countriesWithStates.reduce(
  (acc: Record<string, CountryState[]>, country) => {
    acc[country.isoCode] = country.states;
    return acc;
  },
  {},
);
